/** Public wholesale enquiry only. A saved email is never an access credential. */
const SOURCE_KEY = 'ancartaStockistSource';
const VALID_SOURCES = ['email', 'instagram', 'tiktok', 'ruby', 'perth_outreach', 'direct'];

function initStockistEnquiry() {
  const gate = document.querySelector('.stk-gate');
  if (!gate || gate.dataset.enquiryInitialized === 'true') return;
  gate.dataset.enquiryInitialized = 'true';
  const form = gate.querySelector('[data-ref="gateFormEl"]');
  const panel = gate.querySelector('[data-ref="gateForm"]');
  const received = gate.querySelector('[data-ref="gateReceived"]');
  const emailInput = gate.querySelector('[data-ref="emailInput"]');
  const button = gate.querySelector('[data-ref="gateSubmit"]');
  const label = gate.querySelector('[data-ref="gateSubmitLabel"]');
  const error = gate.querySelector('[data-ref="gateError"]');
  const live = gate.querySelector('[data-ref="gateStatusLive"]');
  if (!form || !emailInput || !button || !received) return;
  let strings = {};
  try {
    strings = JSON.parse(document.querySelector('[data-ancarta-i18n="stockist"]')?.textContent || '{}');
  } catch { /* English fallback remains available. */ }
  const t = (key, fallback) => typeof strings[key] === 'string' && strings[key] ? strings[key] : fallback;
  const publish = (name) => {
    try { window.Shopify?.analytics?.publish?.(name, {}); } catch { /* Analytics must not block an enquiry. */ }
  };
  // Retire the old email-as-unlock state, including browsers that visited before this change.
  try { localStorage.removeItem('ancartaStockistEmail'); } catch { /* Storage may be disabled. */ }
  let source = 'direct';
  const params = new URLSearchParams(window.location.search);
  const incoming = (params.get('source') || params.get('utm_source') || '').toLowerCase();
  try {
    const saved = sessionStorage.getItem(SOURCE_KEY);
    source = VALID_SOURCES.includes(saved) ? saved : VALID_SOURCES.includes(incoming) ? incoming : 'direct';
    sessionStorage.setItem(SOURCE_KEY, source);
  } catch { source = VALID_SOURCES.includes(incoming) ? incoming : 'direct'; }
  publish('stockist_page_view');
  let submitting = false;
  let submitted = false;
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitting || submitted || !form.reportValidity()) return;
    const apiBase = gate.getAttribute('data-api-base') || '';
    const email = emailInput.value.trim();
    if (!email) return;
    if (error) error.hidden = true;
    if (!apiBase) {
      if (error) { error.textContent = t('js_not_configured', 'Please contact support@ancarta.co.'); error.hidden = false; }
      return;
    }
    submitting = true;
    button.disabled = true;
    if (label) label.textContent = t('js_sending', 'SENDING…');
    if (live) live.textContent = t('js_sending', 'Sending…');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(apiBase.replace(/\/$/, '') + '/stockists/access', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
        signal: controller.signal,
      });
      const data = await response.json();
      if (!response.ok || data?.success !== true || data?.status !== 'enquiry_received' || data?.accessGranted !== false) {
        if (error) {
          error.textContent = data?.error === 'invalid_email'
            ? t('js_invalid_email', 'Enter a valid business email address.')
            : t('js_generic', 'Something went wrong. Please try again.');
          error.hidden = false;
        }
        return;
      }
      submitted = true;
      form.reset();
      if (panel) panel.hidden = true;
      received.hidden = false;
      if (live) live.textContent = '';
      received.focus();
      publish('stockist_email_captured');
    } catch {
      if (error) {
        error.textContent = t('js_network_gate', "We couldn't reach Ancarta right now. Please try again.");
        error.hidden = false;
      }
    } finally {
      clearTimeout(timeout);
      submitting = false;
      button.disabled = submitted;
      if (label) label.textContent = t('enquiry_submit', 'ENQUIRE');
      if (!submitted && live) live.textContent = '';
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStockistEnquiry);
else initStockistEnquiry();
document.addEventListener('shopify:section:load', initStockistEnquiry);
